import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormGroup, Validators, ReactiveFormsModule, FormControl, } from '@angular/forms';
import { AlertService } from '../../alert.service';
import { SmsCallService } from '../sms-call.service';
import { LocationService } from '@main/location.service';
import { State } from '@main/state';
import { BusinessAddress } from '../sms-call';

@Component({
  selector: 'app-a2p-registration-business-address',
  templateUrl: './a2p-registration-business-address.component.html',
  styleUrls: ['./a2p-registration-business-address.component.css'],
  imports: [ReactiveFormsModule],
})
export class A2PRegistrationBusinessAddressComponent implements OnInit {

  // Properties
  @Output() proceedToNextStep: EventEmitter<void> = new EventEmitter<void>();
  @Input() businessAddress: BusinessAddress;

  businessAddressForm: FormGroup;

  countryList: { name: string, value: string }[] = [
    {
      name: 'United States',
      value: 'US',
    }
  ];
  states: State[] = [];

  // Injections
  private smsCallService = inject(SmsCallService);
  private locationService = inject(LocationService);
  private alertService = inject(AlertService);

  ngOnInit(): void {
    this.businessAddressForm = new FormGroup({
      businessName: new FormControl(null, Validators.required),
      street: new FormControl(null, Validators.required),
      streetSecondary: new FormControl(null),
      city: new FormControl(null, Validators.required),
      region: new FormControl(null, Validators.required),
      postalCode: new FormControl(null, Validators.required),
      isoCountry: new FormControl("US", Validators.required)
    });
    this.getStates();
    if (this.businessAddress) this.setBusinessAddressForm();
  }

  // Get States
  private getStates(): void {
    this.locationService.getStates().subscribe((states) => {
      this.states = states;
    });
  }

  // Set Business Address Form
  private setBusinessAddressForm(): void {
    this.businessAddressForm.setValue({
      businessName: this.businessAddress.businessName,
      street: this.businessAddress.street,
      streetSecondary: this.businessAddress.streetSecondary,
      city: this.businessAddress.city,
      region: this.businessAddress.region,
      postalCode: this.businessAddress.postalCode,
      isoCountry: this.businessAddress.isoCountry
    });
  }

  // Submit Form
  submitForm(): void {
    if (this.businessAddressForm.valid) {
      const payload = { ...this.businessAddressForm.value };
      if (this.businessAddress) {
        this.smsCallService.updateBusinessAddress({
          ...payload
        }).subscribe(() => {
          this.alertService.showSuccessAlert('Business Address Updated');
          this.proceedToNextStep.emit();
        });
      } else {
        this.smsCallService.createBusinessAddress(payload).subscribe(() => {
          this.alertService.showSuccessAlert('Business Address Saved');
          this.proceedToNextStep.emit();
        });
      }
    }
  }

  // Form Accessors
  get businessName() { return this.businessAddressForm.controls.businessName; }
  get street() { return this.businessAddressForm.controls.street; }
  get streetSecondary() { return this.businessAddressForm.controls.streetSecondary; }
  get city() { return this.businessAddressForm.controls.city; }
  get region() { return this.businessAddressForm.controls.region; }
  get postalCode() { return this.businessAddressForm.controls.postalCode; }
  get isoCountry() { return this.businessAddressForm.controls.isoCountry; }
}
